<template>
    <div class="main">
        <section>
            <div>
              <h2 class="heading">Abgeschlossene Baustellen</h2>
              <div class="filters">
                <div>
                  <input class="filter-input" type="text" placeholder="Suchen..." v-model="bauherrFilter" />
                </div>
              </div>

              <div v-if="archiv.length && filterBauherr.length && bauherrFilter">
                <table>
                    <tbody>
                        <tr class="table-head">
                            <th scope="row">Bauherr</th>
                            <th scope="row">Bauvorhaben</th>
                            <th scope="row">Auftraggeber</th>
                            <th scope="row">Auftragssumme</th>
                            <th scope="row">Abgeschlossen</th>
                            <th scope="row">Erstellt</th>
                            <th scope="row">Archiviert</th>
                            <th scope="row">Details</th>
                        </tr>
                        <tr v-for="baustelle in filterBauherr" v-bind:key="baustelle.id">
                            <td>{{ baustelle.bauherr}}</td>
                            <td>{{ baustelle.adresse}}</td>
                            <td>{{ baustelle.auftraggeber}}</td>
                            <td>{{ baustelle.auftragssumme.toLocaleString()}} €</td>
                            <td>{{ baustelle.ende | formatMonthDate}}</td>
                            <td>{{ baustelle.createdOn | formatDate}}</td>
                            <td>{{ baustelle.archiviert | formatDate}}</td>
                            <td class="button-col">
                              <router-link
                                class="button arrow-button"
                                :to="{ name: 'Archivdetail', params: { id: baustelle.id }}">
                                <span class="material-icons">arrow_forward</span>
                              </router-link>
                          </td>
                        </tr>
                    </tbody>
                </table>
                </div>
                
                <div v-else>
                <table v-if="sorted.length">
                    <tbody>
                        <tr class="table-head">
                            <th scope="row">Bauherr</th>
                            <th scope="row">Bauvorhaben</th>
                            <th scope="row">Auftraggeber</th>
                            <th scope="row">Auftragssumme</th>
                            <th scope="row">Abgeschlossen</th>
                            <th scope="row">Erstellt</th>
                            <th scope="row">Archiviert</th>
                            <th scope="row">Details</th>
                        </tr>
                        <tr v-for="baustelle in sorted" v-bind:key="baustelle.id">
                            <td>{{ baustelle.bauherr}}</td>
                            <td>{{ baustelle.adresse}}</td>
                            <td>{{ baustelle.auftraggeber}}</td>
                            <td>{{ baustelle.auftragssumme.toLocaleString()}} €</td>
                            <td>{{ baustelle.ende | formatMonthDate}}</td>
                            <td>{{ baustelle.createdOn | formatDate}}</td>
                            <td>{{ baustelle.archiviert | formatDate}}</td>
                            <td class="button-col">
                              <router-link
                                class="button arrow-button"
                                :to="{ name: 'Archivdetail', params: { id: baustelle.id }}">
                                <span class="material-icons">arrow_forward</span>
                              </router-link>
                          </td>
                        </tr>
                    </tbody>
                </table>
                <div v-else>
                    <p class="no-results">Keine Einträge vorhanden.</p>
                </div>
                </div>
            </div>     
    </section> 
   </div> 
</template>

<script>
const fb = require("../fbConfig.js");
import moment from "moment";
import { mapState } from "vuex";
import { currentUser } from "../fbConfig";

export default {
  data() {
    return {
      bauherrFilter: "",
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser", "archiv"]),
    filterBauherr: function() {
      let inp = this.bauherrFilter.toLowerCase();
      return this.archiv.filter(obj => {
        return Object.keys(obj).some(
          key =>
            typeof obj[key] === "string" && obj[key].toLowerCase().includes(inp)
        );
      });
    },
    sorted() {
      let arch = this.archiv
      let b = arch.filter(el => {
        if (el.archiviert) {
          if (moment(el.archiviert.seconds).isValid()) {
            return el
          }
        }
      })
      return b.sort((a, b) => moment(b.archiviert.seconds) - moment(a.archiviert.seconds))
    }
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("DD.MM.YYYY");
    },
    formatStrDate(date) {
      return moment(date).format("DD.MM.YYYY");
    },
    formatMonthDate(date) {
      return moment(date).format("MMM YYYY");
    }
  }
};
</script>

<style scoped>
.main {
  margin-top: 100px;
  background: #eeeeee;
  padding: 20px;
  border-radius: 20px;
}

.heading {
  margin-top: 0;
}

table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  margin-top: 20px;
  margin-right: 20px;
  margin-bottom: 20px;
  font-size: 12px;
}

td,
th {
  padding: 0.5rem;
}

tr {
  height: 40px;
}

tr:nth-child(even) {
  background: #e3e3e4;
}

.table-head {
  background: #2c3e50;
  color: #eeeeee;
  font-size: 14px;
}

td,
th {
  border-right: 1px solid rgb(212, 212, 212);
  padding: 0.5rem;
}

td:last-of-type,
th:last-of-type {
  border-right: none;
}

tfoot td {
  border: none;
  background: white;
  padding-left: 0;
}

.first-btn {
  margin-right: 10px;
}

.material-icons {
  vertical-align: middle;
  font-size: 20px;
  margin-bottom: 2px;
}

.arrow-button {
  padding: 5px;
  border-radius: 100px;
  font-size: 15px;
}

.button-col {
  text-align: center;
}

.filters {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}


.filter-input {
  box-sizing: border-box;
  border: 1px solid #999;
  outline: none;
  padding: 5px;
  background: #eeeeee;
  border-radius: 20px;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  width: 200px;
  padding-left: 10px;
}
</style>